import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1, delay: 0.3 }}
      className="w-full bg-padua-dark text-padua-ivory py-16 px-4 mt-20 relative z-20"
    >
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
        <p className="font-serif text-xl md:text-2xl italic text-padua-gold/90 mb-8 max-w-md leading-relaxed">
          "From all of us at Padua Weddings, thank you for being part of our story."
        </p>
        
        <div className="w-12 h-px bg-padua-gold/30 mb-8"></div>
        
        <div className="mb-6">
          <h2 className="font-serif text-lg tracking-widest uppercase">
            Padua Weddings
          </h2>
        </div>
        
        <p className="text-xs md:text-sm text-padua-ivory/50 tracking-wide font-light">
          Historic Southern California Wedding Venue
        </p>
        
        <div className="mt-8 text-[10px] text-padua-ivory/30 uppercase tracking-[0.2em]">
          &copy; {new Date().getFullYear()} Padua Weddings. All rights reserved.
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;